import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { FaBars, FaTimes, FaChevronDown } from 'react-icons/fa';
import './Navbar.css';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsOpen(false);
    setActiveDropdown(null);
  }, [location]);

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About' },
    {
      label: 'The Cosmos',
      path: '/cosmos',
      dropdown: [
        { path: '/cosmos', label: 'The Cosmos' },
        { path: '/our-approach', label: 'Our Approach' },
        { path: '/purpose', label: 'Purpose & Philosophy' }
      ]
    },
    { path: '/services', label: 'Services' },
    { path: '/who-we-work-with', label: 'Who We Work With' },
    { path: '/trilogy-assessment', label: 'Trilogy Assessment' },
    { path: '/contact', label: 'Contact' }
  ];

  return (
    <nav className={`navbar ${scrolled ? 'navbar-scrolled' : ''}`}>
      <div className="container">
        <div className="navbar-content">
          <Link to="/" className="navbar-logo">
            <h2>TRIOLOGY</h2>
          </Link>

          <div className="navbar-links">
            {navLinks.map((link, index) => (
              <div
                key={index}
                className={`navbar-item ${link.dropdown ? 'has-dropdown' : ''}`}
                onMouseEnter={() => link.dropdown && setActiveDropdown(index)}
                onMouseLeave={() => link.dropdown && setActiveDropdown(null)}
              >
                {link.dropdown ? (
                  <>
                    <Link to={link.path} className="navbar-link">
                      {link.label} <FaChevronDown className="dropdown-icon" />
                    </Link>
                    <AnimatePresence>
                      {activeDropdown === index && (
                        <motion.div
                          className="navbar-dropdown"
                          initial={{ opacity: 0, y: 10 }}
                          animate={{ opacity: 1, y: 0 }}
                          exit={{ opacity: 0, y: 10 }}
                          transition={{ duration: 0.2 }}
                        >
                          {link.dropdown.map((subLink) => (
                            <Link
                              key={subLink.path}
                              to={subLink.path}
                              className={`dropdown-link ${location.pathname === subLink.path ? 'active' : ''}`}
                            >
                              {subLink.label}
                            </Link>
                          ))}
                        </motion.div>
                      )}
                    </AnimatePresence>
                  </>
                ) : (
                  <Link
                    to={link.path}
                    className={`navbar-link ${location.pathname === link.path ? 'active' : ''}`}
                  >
                    {link.label}
                  </Link>
                )}
              </div>
            ))}
          </div>

          <button className="navbar-toggle" onClick={() => setIsOpen(!isOpen)}>
            {isOpen ? <FaTimes /> : <FaBars />}
          </button>
        </div>

        <AnimatePresence>
          {isOpen && (
            <motion.div
              className="navbar-mobile"
              initial={{ opacity: 0, height: 0 }}
              animate={{ opacity: 1, height: 'auto' }}
              exit={{ opacity: 0, height: 0 }}
              transition={{ duration: 0.3 }}
            >
              {navLinks.map((link, index) => (
                <div key={index} className="navbar-mobile-item">
                  {link.dropdown ? (
                    <>
                      <div
                        className="navbar-mobile-link dropdown-toggle"
                        onClick={() => setActiveDropdown(activeDropdown === index ? null : index)}
                      >
                        {link.label} <FaChevronDown className={`dropdown-icon ${activeDropdown === index ? 'rotate' : ''}`} />
                      </div>
                      <AnimatePresence>
                        {activeDropdown === index && (
                          <motion.div
                            className="navbar-mobile-dropdown"
                            initial={{ opacity: 0, height: 0 }}
                            animate={{ opacity: 1, height: 'auto' }}
                            exit={{ opacity: 0, height: 0 }}
                          >
                            {link.dropdown.map((subLink) => (
                              <Link
                                key={subLink.path}
                                to={subLink.path}
                                className={`navbar-mobile-sublink ${location.pathname === subLink.path ? 'active' : ''}`}
                              >
                                {subLink.label}
                              </Link>
                            ))}
                          </motion.div>
                        )}
                      </AnimatePresence>
                    </>
                  ) : (
                    <Link
                      to={link.path}
                      className={`navbar-mobile-link ${location.pathname === link.path ? 'active' : ''}`}
                    >
                      {link.label}
                    </Link>
                  )}
                </div>
              ))}
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </nav>
  );
};

export default Navbar;

